// Ireland products are Thrillophilia imports only; Scandinavia combos are listed on every Nordic country they visit.
import { irelandClassicCircuitDublinGalwayProduct } from './irelandClassicCircuitDublinGalwayData';
import { irelandHoneymoonWildAtlanticProduct } from './irelandHoneymoonWildAtlanticData';

export const irelandProducts = [
  irelandClassicCircuitDublinGalwayProduct,
  irelandHoneymoonWildAtlanticProduct
];
export const irelandTours = [];
export const irelandBySlug = {};
